if (!customElements.get('goose-cart-whatsapp')) {
  class GooseCartWhatsapp extends HTMLElement {
    connectedCallback() {
      this.onClick = (event) => {
        const link = event.target.closest('[data-goose-whatsapp]');
        if (!link || !this.contains(link)) return;
        event.preventDefault();
        this.openWhatsapp(link);
      };
      this.addEventListener('click', this.onClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
    }

    getCheckoutUrl(value) {
      const url = new URL(value);
      const hosts = new Set([window.location.hostname, this.dataset.shopDomain]);
      if (this.dataset.storeUrl) hosts.add(new URL(this.dataset.storeUrl).hostname);
      const checkoutPath = url.pathname.split('/checkouts/')[1];
      const checkoutToken = checkoutPath?.startsWith('cn/') ? checkoutPath.slice(3).split('/')[0] : checkoutPath?.split('/')[0];
      const isCheckout = Boolean(checkoutToken && checkoutToken !== 'cn')
        || /\/cart\/c\/[^/]+\/?$/.test(url.pathname);
      if (url.protocol !== 'https:' || !hosts.has(url.hostname) || url.username || url.password || !isCheckout) {
        throw new Error(this.dataset.error);
      }
      return url.href;
    }

    async getCartCheckoutUrl(cart, signal) {
      if (typeof cart.token !== 'string' || !cart.token.trim()) throw new Error(this.dataset.error);
      const id = cart.token.startsWith('gid://shopify/Cart/') ? cart.token : `gid://shopify/Cart/${cart.token}`;
      const response = await fetch(new URL('/api/2026-07/graphql.json', window.location.origin).href, {
        method: 'POST',
        credentials: 'same-origin',
        cache: 'no-store',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          query: 'query GooseCartCheckout($id: ID!, $language: LanguageCode!) @inContext(language: $language) { cart(id: $id) { checkoutUrl } }',
          variables: { id, language: this.dataset.language === 'en' ? 'EN' : 'ES' },
        }),
        signal,
      });
      if (!response.ok) throw new Error(this.dataset.error);
      const result = await response.json();
      if (result.errors?.length || !result.data?.cart?.checkoutUrl) throw new Error(this.dataset.error);
      return this.getCheckoutUrl(result.data.cart.checkoutUrl);
    }

    buildMessage(cart, checkoutUrl) {
      const products = cart.items.filter((item) => !item.properties?._Servicio).slice(0, 5).map((item) => {
        const variant = item.variant_title && item.variant_title !== 'Default Title' ? ` (${item.variant_title})` : '';
        return `${item.product_title}${variant} × ${item.quantity}.`;
      });
      return [this.dataset.message, products.join('\n'), `${this.dataset.checkoutLabel}\n${checkoutUrl}`].join('\n\n');
    }

    async openWhatsapp(link) {
      if (this.busy) return;
      const status = this.querySelector('[data-goose-whatsapp-status]');
      const cartLock = typeof CartItems === 'undefined' ? null : CartItems;
      if (cartLock?.changePending) {
        status.textContent = this.dataset.wait;
        status.focus();
        return;
      }
      this.busy = true;
      if (cartLock) cartLock.changePending = true;
      const text = this.querySelector('[data-goose-whatsapp-text]');
      const originalText = text.textContent;
      const controls = [...document.querySelectorAll('cart-drawer .quantity__button, cart-drawer .quantity__input, cart-drawer cart-remove-button button, cart-items .quantity__button, cart-items .quantity__input, cart-items cart-remove-button button, [name="checkout"], [data-goose-discount] button, [data-goose-add] button, [data-goose-add] select')].map((control) => ({ control, disabled: control.disabled }));
      controls.forEach(({ control }) => { control.disabled = true; });
      status.textContent = '';
      text.textContent = this.dataset.loading;
      link.setAttribute('aria-disabled', 'true');
      this.setAttribute('aria-busy', 'true');
      let popup = null;
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 15000);
      try {
        try {
          popup = window.open('about:blank', '_blank');
          if (popup) popup.opener = null;
        } catch (popupError) {}
        const cartUrl = new URL(this.dataset.cartUrl, window.location.origin);
        if (cartUrl.origin !== window.location.origin) throw new Error(this.dataset.error);
        const cartResponse = await fetch(`${cartUrl.href}.js`, { credentials: 'same-origin', cache: 'no-store', signal: controller.signal });
        if (!cartResponse.ok) throw new Error(this.dataset.error);
        const cart = await cartResponse.json();
        if (!cart.items?.length) throw new Error(this.dataset.error);
        const checkoutUrl = await this.getCartCheckoutUrl(cart, controller.signal);
        const whatsappUrl = new URL('https://wa.me/527223538434');
        whatsappUrl.searchParams.set('text', this.buildMessage(cart, checkoutUrl));
        if (popup) {
          if (popup.closed) return;
          popup.location.replace(whatsappUrl.href);
        } else {
          window.location.assign(whatsappUrl.href);
        }
      } catch (error) {
        if (popup && !popup.closed) popup.close();
        status.textContent = this.dataset.error;
        status.focus();
      } finally {
        clearTimeout(timeout);
        controls.forEach(({ control, disabled }) => { if (control.isConnected) control.disabled = disabled; });
        text.textContent = originalText;
        link.removeAttribute('aria-disabled');
        this.removeAttribute('aria-busy');
        if (cartLock) cartLock.changePending = false;
        this.busy = false;
      }
    }
  }
  customElements.define('goose-cart-whatsapp', GooseCartWhatsapp);
}
